export const getPublicAssetPath = (path: string): string => {
    return `/${path}`;
};
